<div class="pet-tile-review-container">
  <div class="lato bold primary mt-1">
    {{
      petInfo.firstName
        ? petInfo.firstName + " " + petInfo.lastName
        : petInfo.name
    }}
  </div>
  <div class="pet-info-table">
    <div class="row no-gutters">
      <div class="pet-info-label pr-2">Breed:</div>
      <div class="pet-tile-review-content">{{ breedNameList }}</div>
    </div>
    <div class="row no-gutters">
      <div class="pet-info-label pr-2">Weight:</div>
      <div class="pet-tile-review-content">
        {{ petWeightObject?.weight}} lbs
      </div>
    </div>
  </div>
  <div
    *ngIf="petInfo.details"
    class="pet-tile-review-content"
    style="white-space: pre-line"
  >
    {{ petInfo.details }}
  </div>
</div>
